import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, Checkbox } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from './Contents/DisputeResolution';

export default class DisputeResolution extends Component {
  componentDidMount() {
    const options = this.options();
    const state = this.getState();
    this.props.updateBlock(
      this.props.block.id,
      getContent(options, state.field1, state.type),
      options
    );
  }

  options = () => ({
    field1: this.props.field1,
    field2: this.props.field2,
    field3: this.props.field3,
  });

  handleContent(field, value) {
    const options = this.options();
    options[field] = value;

    if (field === 'field2' && value === true) {
      options.field3 = false;
    } else if (field === 'field3' && value === true) {
      options.field2 = false;
    }

    const state = this.getState();
    this.props.updateBlock(
      this.props.block.id,
      getContent(options, state.field1),
      options
    );
  }

  getState() {
    const { blocks } = this.props;
    let state = { field1: '' };
    const block = R.find(R.propEq('name', 'Governing Law'))(blocks);

    if (block && block.options) {
      state = block.options;
    }

    return state;
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <p className="question">
              If a dispute arises, how should it be handled?
            </p>
            <FormGroup className="answer">
              <Checkbox
                checked={this.props.field1 === true}
                readOnly
                onClick={(e) => this.handleContent('field1', e.target.checked)}
              >
                We will try professional mediation.
              </Checkbox>
              <Checkbox
                checked={this.props.field2 === true}
                readOnly
                onClick={(e) => this.handleContent('field2', e.target.checked)}
              >
                We agree to binding arbitration.
              </Checkbox>
              <Checkbox
                checked={this.props.field3 === true}
                readOnly
                onClick={(e) => this.handleContent('field3', e.target.checked)}
              >
                We will submit our disagreement to a court of law in the region
                we have chosen.
              </Checkbox>
              <i className="text-gray small">
                Please specify the region in Governing Law tab.
              </i>
            </FormGroup>
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  This clause outlines the paths collaborators can take to try
                  to resolve any problems between them. Agreeing on this now
                  (before there are any problems) can save you the time and
                  frustration of having to deal with it later when others may be
                  less cooperative.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is mediation?</p>
                <p className="small">
                  Mediation is a voluntary process where both parties and their
                  attorneys work with a neutral third party to reach a
                  resolution. The third party acts as a mediator only and does
                  not decide the outcome of the dispute.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is arbitration?</p>
                <p className="small">
                  Arbitration is a private process that is an alternative to
                  going to court. It involves one or more neutral third parties
                  (arbitrators) that make a binding decision to resolve the
                  dispute. While every dispute may vary, arbitration is
                  generally a faster, confidential, and more cost-effective
                  means of dispute resolution. However, by agreeing exclusively
                  to arbitration, the parties waive their right to a trial by
                  jury, the appeals process, and other rights.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/DisputeResolution.jsx